import React, { useRef, useEffect, useState } from "react";
import PageTitle from "../../../components/partials/PageTitle";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import GeneralInformation from "../../../components/policy/GeneralInformation";
import Cover from "../../../components/policy/Cover";
import Interest from "../../../components/policy/Interest";
import Accounting from "../../../components/policy/Accounting";
import Settings from "../../../components/policy/Settings";
import {
  getPolicyCoverByCategory,
  resetPolicyStatus,
} from "../../../redux/slice/policy/policySlice";

const GeneralCoverpolicyConfig = () => {
  const { isSuccess } = useSelector((state) => state?.policy);
  const { user } = useSelector((state) => state?.auth?.user);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const breadcrumb = {
    from: {
      title: "policy",
      link: "/admin/policy-configuration",
    },
    current: {
      title: "policy configuration",
      link: null,
    },
  };

  const [generalInformation, setGeneralInformation] = useState(null);
  const [interest, setInterest] = useState(null);
  const [accounting, setAccounting] = useState(null);
  const [cover, setCover] = useState([]);
  const [policyConfig, setPolicyConfig] = useState({});
  const [preview, setPreview] = useState(false);

  const genInfoRef = useRef();
  const interestRef = useRef();
  const accountingRef = useRef();
  const coverRef = useRef();
  const policyCreateCloseRef = useRef();
  const settingsRef = useRef();

  useEffect(() => {
    setPolicyConfig({
      ...policyConfig,
      p_general_information: generalInformation,
      p_cover: cover,
      p_interest: interest,
      p_account: accounting,
    });
  }, [generalInformation, interest, accounting, cover]);

  useEffect(() => {
    if (isSuccess) {
      policyCreateCloseRef.current.click();
      dispatch(resetPolicyStatus());
      navigate("/admin/all-policies");
    }
  }, [isSuccess]);

  useEffect(() => {
    dispatch(getPolicyCoverByCategory(1));
    if (
      !user_permissions?.some(
        (permission) => permission.name === "settings module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "policy configuration module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create policy"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Configuration' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card position-relative'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary '>
                    Creating General Cover Policy
                  </h4>
                  <span
                    onClick={() => navigate(-1)}
                    className='btn btn-primary btn-sm float-end '
                  >
                    Go Back
                  </span>
                </div>
              </div>
              <div>
                <ul className='nav nav-pills bg-nav-pills nav-justified mb-3'>
                  <li className='nav-item'>
                    <a
                      href='#general_information'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 active border'
                      ref={genInfoRef}
                    >
                      <i className='mdi mdi-home-variant d-md-none d-block'></i>
                      <span className='d-none d-md-block'>
                        General Information
                      </span>
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='#cover'
                      data-bs-toggle='tab'
                      aria-expanded='true'
                      className='nav-link rounded-0 border'
                      ref={coverRef}
                    >
                      <i className='mdi mdi-account-circle d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Policy Cover</span>
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='#interest'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={interestRef}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Rate</span>
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      href='#genAccounting'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={accountingRef}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Accounting</span>
                    </a>
                  </li>
                  <li className='nav-item '>
                    <a
                      href='#setting'
                      data-bs-toggle='tab'
                      aria-expanded='false'
                      className='nav-link rounded-0 border'
                      ref={settingsRef}
                    >
                      <i className='mdi mdi-settings-outline d-md-none d-block'></i>
                      <span className='d-none d-md-block'>Settings</span>
                    </a>
                  </li>
                </ul>

                <div className='tab-content'>
                  <div
                    className='tab-pane show active'
                    id='general_information'
                  >
                    <GeneralInformation
                      getGenerallInfo={setGeneralInformation}
                      interestRef={interestRef}
                      coverRef={coverRef}
                    />
                  </div>
                  <div className='tab-pane' id='cover'>
                    <Cover
                      interestRef={interestRef}
                      genInfoRef={genInfoRef}
                      setCover={setCover}
                    />
                  </div>
                  <div className='tab-pane' id='interest'>
                    <Interest
                      coverRef={coverRef}
                      accountingRef={accountingRef}
                      genInfoRef={genInfoRef}
                      setInterest={setInterest}
                    />
                  </div>
                  <div className='tab-pane' id='genAccounting'>
                    <Accounting
                      interestRef={interestRef}
                      settingsRef={settingsRef}
                      setAccounting={setAccounting}
                    />
                  </div>
                  <div className='tab-pane' id='setting'>
                    <Settings
                      accountingRef={accountingRef}
                      coverRef={coverRef}
                      policyConfig={policyConfig}
                      interestRef={interestRef}
                      genInfoRef={genInfoRef}
                      policyCreateCloseRef={policyCreateCloseRef}
                      setPreview={setPreview}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralCoverpolicyConfig;
